import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MainPageComponent } from '@features/main-page/main-page.component';
import { OverviewPageComponent } from '@features/overview-page/overview-page.component';
import { QuotationPageComponent } from '@features/quotation-page/quotation-page.component';
import { BlindConfigurationGuard } from '@core/quards/blind-configuration.guard';
import { ShopGuard } from '@core/quards/shop.guard';

const routes: Routes = [
	{ path: '', redirectTo: '/home', pathMatch: 'full' },
	{ path: 'home', component: MainPageComponent },
	{ path: 'overview', component: OverviewPageComponent, canActivate: [BlindConfigurationGuard] },
	{ path: 'quote', component: QuotationPageComponent, canActivate: [BlindConfigurationGuard, ShopGuard] },
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes, {
			scrollPositionRestoration: 'enabled',
			anchorScrolling: 'enabled',
		}),
	],
	exports: [RouterModule],
})
export class AppRoutingModule {}
